(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[67],{

/***/ 73546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */
const useEnhancedEffect = typeof window !== 'undefined' ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;
/* harmony default export */ __webpack_exports__["Z"] = (useEnhancedEffect);

/***/ }),

/***/ 59948:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _useEnhancedEffect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73546);
'use client';




/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */

function useEventCallback(fn) {
  const ref = react__WEBPACK_IMPORTED_MODULE_0__.useRef(fn);
  (0,_useEnhancedEffect__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(() => {
    ref.current = fn;
  });
  return react__WEBPACK_IMPORTED_MODULE_0__.useRef((...args) =>
  // @ts-expect-error hide `this`
  (0, ref.current)(...args)).current;
}
/* harmony default export */ __webpack_exports__["Z"] = (useEventCallback);

/***/ }),

/***/ 86010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export clsx */
function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}/* harmony default export */ __webpack_exports__["Z"] = (clsx);

/***/ }),

/***/ 89479:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/videos",
      function () {
        return __webpack_require__(51263);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 37677:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

const { default: Image  } = __webpack_require__(25675);
const { useState  } = __webpack_require__(67294);
const PhotoBox = (param)=>{
    let { src , width , height , alt , bro , ...props } = param;
    const [isShow, setIsShow] = useState(true);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: isShow ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Image, {
                    src: src,
                    width: width,
                    height: height,
                    alt: alt,
                    onError: ()=>setIsShow(false),
                    ...props
                }),
                bro
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PhotoBox);


/***/ }),

/***/ 74743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61906);
/* harmony import */ var _ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74249);
/* harmony import */ var _ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3__);




const ContentLoading = (param)=>{
    let { label , fullScreen =false , className =""  } = param;
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("common");
    const text = label || t("Loading...");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        role: "status",
        "aria-live": "polite",
        "aria-label": text,
        className: "".concat((_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingRoot), " ").concat(fullScreen ? (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingRootFullScreen) : "", " ").concat(className).trim(),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                src: "/images/loading/spinner.svg",
                alt: "",
                width: 64,
                height: 64,
                className: (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingSpinner),
                "aria-hidden": "true",
                priority: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingLabel),
                children: text
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContentLoading);


/***/ }),

/***/ 82017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ useDeviceScopedInit; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9473);
/* harmony import */ var src_store_apps_Common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34745);



/**

 * 当前选中设备变化时重新执行初始化逻辑（拉数、重置本地 state 等）。

 * 通过 requestKey 与 AbortSignal 丢弃切换前未完成的异步请求。

 *

 * @param {(deviceUser: string, scope: {

 *   context: Object,

 *   signal: AbortSignal,

 *   isCurrent: () => boolean

 * }) => void} initFn - 设备作用域初始化回调，需 useCallback 包裹

 */ function useDeviceScopedInit(initFn) {
    const deviceUser = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)((state)=>state.Common.deviceUser);
    const context = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(src_store_apps_Common__WEBPACK_IMPORTED_MODULE_2__/* .selectDeviceContext */ .VQ);
    const requestKey = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(src_store_apps_Common__WEBPACK_IMPORTED_MODULE_2__/* .selectDeviceRequestKey */ .rx);
    const contextRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(context);
    contextRef.current = context;
    const effectiveDeviceUser = deviceUser || (context === null || context === void 0 ? void 0 : context.accountId) || (context === null || context === void 0 ? void 0 : context.username);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!effectiveDeviceUser) return;
        const controller = new AbortController();
        let active = true;
        const scopedContext = contextRef.current;
        // 仅当 requestKey 仍与当前 Redux 一致时，才应用异步结果
        const isCurrent = ()=>{
            var ref;
            return active && !controller.signal.aborted && ((ref = contextRef.current) === null || ref === void 0 ? void 0 : ref.requestKey) === requestKey;
        };
        initFn(effectiveDeviceUser, {
            context: scopedContext,
            signal: controller.signal,
            isCurrent
        });
        return ()=>{
            active = false;
            controller.abort();
        };
    }, [
        effectiveDeviceUser,
        initFn,
        requestKey
    ]);
}


/***/ }),

/***/ 51263:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ ModalUnstyledDemo; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61906);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(86010);
/* harmony import */ var _mui_material_Modal__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(96664);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(90948);
/* harmony import */ var _iconify_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1954);
/* harmony import */ var src_api_dashboard__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95629);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9473);
/* harmony import */ var src_store_apps_Common__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(34745);
/* harmony import */ var src_core_components_photos_PhotoBox__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(37677);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(50607);
/* harmony import */ var src_hooks_useDeviceScopedInit__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(82017);
/* harmony import */ var src_components_ContentLoading__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(74743);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  z-index: -1;\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  top: 0;\n  left: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  -webkit-tap-highlight-color: transparent;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}















// request








const BackdropUnstyled = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.forwardRef((props, ref)=>{
    const { open , className , ...other } = props;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
            "MuiBackdrop-open": open
        }, className),
        ref: ref,
        ...other
    });
});
BackdropUnstyled.propTypes = {
    className: (prop_types__WEBPACK_IMPORTED_MODULE_14___default().string.isRequired),
    open: (prop_types__WEBPACK_IMPORTED_MODULE_14___default().bool)
};
const Backdrop = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(BackdropUnstyled)(_templateObject());
const RegisterIllustration = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)("img")((param)=>{
    let { theme  } = param;
    return {
        [theme.breakpoints.down("lg")]: {
            height: 500
        }
    };
});
function formateSeconds(endTime) {
    let secondTime = parseInt(endTime) //将传入的秒的值转化为Number
    ;
    let min = 0 // 初始化分
    ;
    let h = 0 // 初始化小时
    ;
    let result = "";
    if (secondTime > 60) {
        min = parseInt(secondTime / 60);
        secondTime = parseInt(secondTime % 60);
        if (min > 60) {
            h = parseInt(min / 60);
            min = parseInt(min % 60);
        }
    }
    result = "".concat(min.toString().padStart(2, "0"), ":").concat(secondTime.toString().padStart(2, "0"));
    return result;
}
function ModalUnstyledDemo() {
    let Basic = window.localStorage.getItem("Basic");
    Basic = Basic == null || Basic == 0 ? true : false;
    const scopeRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    const reloadRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    const loadNextRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    // 文件夹
    const [albumSummary, setAlbumSummary] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]);
    const photosPaseUrl = "https://cos.spyx.com/";
    // 目录层级
    const [level, setLevel] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0);
    // 选中数据
    const [selectedData, setSelectedData] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]);
    // 预览图片
    const [photodata, setPhotoData] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({});
    // 模态框
    const [open, setOpen] = react__WEBPACK_IMPORTED_MODULE_2__.useState(false);
    // 只存储图片数据
    const [useImages, setImages] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]);
    // 当前选择页数
    const [total, setTotal] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0);
    // 当前文件夹id
    const [fileRid, setFileRid] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    // 滚动dom的ref
    const videoRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    // 分页参数
    const [pagination, setPagination] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        reqNum: 50,
        nowOffset: 0,
        maxNum: false // 全部数据查询完毕
    });
    // 当前行参数
    const [row, setRow] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null);
    // 滚动百分比
    const [scroll, setScroll] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0);
    const [isLoading, setIsLoading] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true) //正在加载获取数据
    ;
    // 获取滚动百分比
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        const handScroll = ()=>{
            if (videoRef.current) {
                const { scrollTop , scrollHeight , clientHeight  } = videoRef.current;
                const progress = scrollTop / (scrollHeight - clientHeight) * 100;
                setScroll(progress.toFixed(0));
            }
        };
        const currentRef = videoRef.current;
        if (currentRef) {
            currentRef.addEventListener("scroll", handScroll);
        }
        return ()=>{
            if (currentRef) {
                currentRef.removeEventListener("scroll", handScroll);
            }
        };
    }, []);
    // 监听滚动百分比
    loadNextRef.current = ()=>{
        const nowOffset = pagination.nowOffset + pagination.reqNum;
        setPagination((page)=>({
                ...page,
                nowOffset
            }));
        if (!pagination.maxNum) handleSelectedPhotos({
            row,
            nowOffset
        }, scopeRef.current);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        var ref;
        if (scroll >= 100) (ref = loadNextRef.current) === null || ref === void 0 ? void 0 : ref.call(loadNextRef);
    }, [
        scroll
    ]);
    reloadRef.current = (scope)=>{
        // 文件夹
        const setAlbumSummaryData = async ()=>{
            const { context , signal , isCurrent  } = scope;
            const response = await (0,src_api_dashboard__WEBPACK_IMPORTED_MODULE_6__/* .getGcloudAll */ .U1)({
                username: (context === null || context === void 0 ? void 0 : context.username) || "",
                params: {
                    category: "ALBUM_SUMMARY",
                    ...(context === null || context === void 0 ? void 0 : context.physicalDeviceKey) ? {
                        deviceUdid: context.physicalDeviceKey
                    } : {}
                }
            }, {
                signal
            });
            if (!isCurrent()) return;
            if (response.data.contents != null) {
                response.data.contents = response.data.contents.filter((row)=>row.name == "All Videos");
                // let result = response.data.contents.map(item => {
                //   let url = ''
                //   if (item.amount == 0) {
                //     url = '/images/photos/no-photos.png'
                //   } else {
                //     url = item.cover == null ? photosPaseUrl + item.url : photosPaseUrl + item.cover.url
                //   }
                //   return {
                //     ...item,
                //     url: url
                //   }
                // })
                // setLevel(0)
                // setAlbumSummary(result)
                if (response.data.contents.length !== 0) {
                    setRow(response.data.contents[0]);
                    const row = response.data.contents[0];
                    await handleSelectedPhotos({
                        row,
                        nowOffset: 0
                    }, scope);
                }
            } else {
                setIsLoading(false);
            }
        };
        setAlbumSummaryData().catch((error)=>{
            if (scope.isCurrent() && (error === null || error === void 0 ? void 0 : error.code) !== "ERR_CANCELED") {
                ;
                setIsLoading(false);
            }
        });
    };
    // 设备切换时重置视频列表并重新拉数
    (0,src_hooks_useDeviceScopedInit__WEBPACK_IMPORTED_MODULE_11__/* .useDeviceScopedInit */ .A)((0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((_, scope)=>{
        var ref;
        scopeRef.current = scope;
        setAlbumSummary([]);
        setLevel(0);
        setSelectedData([]);
        setPhotoData({});
        setOpen(false);
        setImages([]);
        setTotal(0);
        setFileRid("");
        setPagination({
            reqNum: 50,
            nowOffset: 0,
            maxNum: false
        });
        setRow(null);
        setScroll(0);
        setIsLoading(true);
        (ref = reloadRef.current) === null || ref === void 0 ? void 0 : ref.call(reloadRef, scope);
    }, []));
    const handleSelectedPhotos = async function(param) {
        let { row , nowOffset =0  } = param, scope = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : scopeRef.current;
        if (!scope || !row) return;
        const { context , signal , isCurrent  } = scope;
        setFileRid(row.id);
        const response = await (0,src_api_dashboard__WEBPACK_IMPORTED_MODULE_6__/* .getGcloudAll */ .U1)({
            username: (context === null || context === void 0 ? void 0 : context.username) || "",
            params: {
                category: "ALBUM_DETAIL",
                offset: nowOffset,
                limit: pagination.reqNum,
                rid: row.id,
                ...(context === null || context === void 0 ? void 0 : context.physicalDeviceKey) ? {
                    deviceUdid: context.physicalDeviceKey
                } : {}
            }
        }, {
            signal
        });
        if (!isCurrent()) return;
        setTotal(response.data.totalCount);
        setIsLoading(false);
        if (response.data.contents === null) {
            setLevel(1);
            setSelectedData((old)=>[
                    ...old
                ]);
            setPagination((page)=>({
                    ...page,
                    maxNum: true
                }));
            return;
        }
        let result = response.data.contents.map((item)=>{
            return {
                ...item,
                original_url: item.original.url,
                medium_url: item.medium.url,
                thumb_url: item.thumb.url,
                width: item.thumb.width,
                type: item.thumb.type == "mp4" || item.thumb.type == "mov" || item.thumb.type == "video" ? "mp4" : item.thumb.type,
                cover_url: item.thumb.type == "mp4" || item.thumb.type == "mov" || item.thumb.type == "video" ? item.cover.url : "",
                cover_duration: item.thumb.type == "mp4" || item.thumb.type == "mov" || item.thumb.type == "video" ? formateSeconds(item.cover.duration) : ""
            };
        });
        setLevel(1);
        setSelectedData((old)=>[
                ...old,
                ...result
            ]);
        // 图片独立存储一份
        let images = result.filter((item)=>{
            return item.type != "mp4";
        });
        setImages((old)=>[
                ...old,
                ...images
            ]);
    };
    // 打开模态框
    const handleOpen = ()=>{
        setOpen(true);
    };
    // 关闭
    const handleClose = ()=>setOpen(false);
    const openSetPhotoData = (result)=>{
        if (JSON.stringify(result.medium) != "{}") {
            setPhotoData({
                id: result.id,
                ...result.medium
            });
        } else {
            setPhotoData({
                id: result.id,
                ...result.original
            });
        }
    };
    // 上一个图片
    const previousPhotos = ()=>{
        let index = useImages.findIndex((item)=>{
            return item.id == photodata.id;
        });
        let result = useImages[index - 1];
        if (typeof result === "undefined") return;
        if (JSON.stringify(result.medium) != "{}") {
            setPhotoData({
                id: result.id,
                ...result.medium
            });
        } else {
            setPhotoData({
                id: result.id,
                ...result.original
            });
        }
    };
    //  下一个图片
    const nextPhotos = ()=>{
        let index = useImages.findIndex((item)=>{
            return item.id == photodata.id;
        });
        let result = useImages[index + 1];
        if (typeof result === "undefined") return;
        if (JSON.stringify(result.medium) != "{}") {
            setPhotoData({
                id: result.id,
                ...result.medium
            });
        } else {
            setPhotoData({
                id: result.id,
                ...result.original
            });
        }
    };
    // 分页
    const onChangePage = async (page, pageSize)=>{
        const scope = scopeRef.current;
        if (!scope) return;
        const { context , signal , isCurrent  } = scope;
        const response = await (0,src_api_dashboard__WEBPACK_IMPORTED_MODULE_6__/* .getGcloudAll */ .U1)({
            username: (context === null || context === void 0 ? void 0 : context.username) || "",
            params: {
                category: "ALBUM_DETAIL",
                offset: (page - 1) * pageSize,
                limit: pageSize,
                rid: fileRid,
                ...(context === null || context === void 0 ? void 0 : context.physicalDeviceKey) ? {
                    deviceUdid: context.physicalDeviceKey
                } : {}
            }
        }, {
            signal
        });
        if (!isCurrent()) return;
        setTotal(response.data.totalCount);
        if (response.data.contents === null) {
            setLevel(1);
            setSelectedData([]);
            return;
        }
        let result = response.data.contents.map((item)=>{
            return {
                ...item,
                original_url: item.original.url,
                medium_url: item.medium.url,
                thumb_url: item.thumb.url,
                width: item.thumb.width,
                type: item.thumb.type == "mp4" || item.thumb.type == "mov" || item.thumb.type == "video" ? "mp4" : item.thumb.type,
                cover_url: item.thumb.type == "mp4" || item.thumb.type == "mov" || item.thumb.type == "video" ? item.cover.url : "",
                cover_duration: item.thumb.type == "mp4" || item.thumb.type == "mov" || item.thumb.type == "video" ? formateSeconds(item.cover.duration) : "",
                play: false
            };
        });
        setLevel(1);
        setSelectedData(result);
        // 图片独立存储一份
        let images = result.filter((item)=>{
            return item.type != "mp4";
        });
        setImages(images);
    };
    // 返回目录
    const goBack = ()=>{
        setLevel(0);
    };
    const listHeight = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    const [videoHeight, setVideoHeight] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0);
    const [currentVideo, setCurrentVideo] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({});
    // 播放视频模态框
    const [videoModalOpen, setVideoModalOpen] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    // 关闭视频模态框
    const cancelVideoModalOpen = ()=>{
        setVideoModalOpen(false);
        setCurrentVideo({});
    };
    // 当前视频对象
    const palyVideo = (row)=>{
        setVideoHeight(listHeight.current.clientHeight);
        setVideoModalOpen(true);
        setCurrentVideo(row);
    };
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("common");
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_8__/* .useDispatch */ .I0)();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_9__/* .setCurrentTab */ .Lw)(t("Video")));
        return ()=>dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_9__/* .setCurrentTab */ .Lw)(""));
    }, [
        dispatch,
        t
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: "bg-[#FFF] drop-shadow-[0_0_12px_rgba(0,0,0,0.13)] rounded-[10px] Bxl:h-[calc(var(--vh2)*100-90px)] Bxls:Headers5:h-[calc(var(--vh2)*100-145px)] Header5:big:h-[calc(var(--vh2)*100-210px)] bigs:h-[calc(var(--vh2)*100-270px)] flex flex-col relative",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    ref: videoRef,
                    className: "py-[12px] grid gap-x-[9px] gap-y-[11px] sm:gap-x-1 grid-cols-2 Sixmds:grid-cols-4 Blds:grid-cols-6 overflow-auto",
                    children: [
                        selectedData.map((item)=>{
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                ref: listHeight,
                                children: item.type != "mp4" && item.type != "video" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: "h-full",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        onClick: handleOpen,
                                        className: "cursor-pointer",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_core_components_photos_PhotoBox__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                            src: photosPaseUrl + item.thumb_url,
                                            onClick: ()=>openSetPhotoData(item),
                                            alt: item.filename,
                                            width: 0,
                                            height: 0,
                                            className: "cursor-pointer w-full",
                                            bro: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                className: "w-full text-[12px] pt-[8px] text-[#000]",
                                                children: [
                                                    item.created && dayjs__WEBPACK_IMPORTED_MODULE_7___default()(item.created).format("YYYY/MM/DD HH:mm"),
                                                    item.date && dayjs__WEBPACK_IMPORTED_MODULE_7___default().unix(item.date).format("YYYY/MM/DD HH:mm")
                                                ]
                                            })
                                        })
                                    })
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                    children: item.play ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        style: {
                                            position: "relative",
                                            width: "100%",
                                            height: "100%",
                                            overflow: "hidden"
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("video", {
                                            controls: true,
                                            autoPlay: false,
                                            id: "video",
                                            preload: "none",
                                            loop: false,
                                            muted: false,
                                            style: {
                                                width: "100%",
                                                height: "100%",
                                                maxHeight: videoHeight + "px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("source", {
                                                    src: photosPaseUrl + item.thumb_url
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("source", {
                                                    src: "movie.ogg",
                                                    type: "video/ogg"
                                                })
                                            ]
                                        })
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        style: {
                                            position: "relative",
                                            width: "100%",
                                            height: "100%"
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_core_components_photos_PhotoBox__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                            src: photosPaseUrl + item.cover_url,
                                            alt: item.filename,
                                            width: 0,
                                            height: 0,
                                            className: "cursor-pointer w-full",
                                            onClick: ()=>palyVideo(item),
                                            bro: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                        className: "w-full text-[12px] pt-[8px] text-[#000]",
                                                        children: [
                                                            item.created && dayjs__WEBPACK_IMPORTED_MODULE_7___default()(item.created).format("YYYY/MM/DD HH:mm"),
                                                            item.date && dayjs__WEBPACK_IMPORTED_MODULE_7___default().unix(item.date).format("YYYY/MM/DD HH:mm")
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                                        src: "/images/photos/play.png",
                                                        width: 30,
                                                        height: 30,
                                                        alt: "play",
                                                        style: {
                                                            position: "absolute",
                                                            top: "50%",
                                                            left: "50%",
                                                            transform: "translate(-50%, -36px)"
                                                        },
                                                        className: "cursor-pointer",
                                                        onClick: ()=>palyVideo(item)
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                        style: {
                                                            position: "absolute",
                                                            bottom: "0",
                                                            right: "4px",
                                                            color: "#fff",
                                                            fontSize: "14px"
                                                        },
                                                        className: "cursor-pointer",
                                                        onClick: ()=>palyVideo(item),
                                                        children: item.cover_duration
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                })
                            }, item.id);
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Modal__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                            zIndex: 1200,
                            "aria-labelledby": "unstyled-modal-title",
                            "aria-describedby": "unstyled-modal-description",
                            open: open,
                            onClose: handleClose,
                            slots: {
                                backdrop: Backdrop
                            },
                            className: "",
                            style: {
                                position: "fixed",
                                width: "100%",
                                zIndex: "1300",
                                right: "0",
                                bottom: "0",
                                top: "0",
                                left: "0",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: " rounded-sm mx-auto",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    className: "flex relative w-full items-center justify-center shadow-2x",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(RegisterIllustration, {
                                            src: "https://cos.spyx.com/" + photodata.url
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            className: " flex w-full absolute",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                    className: "flex items-center justify-star cursor-pointer w-1/2 md:h-[400px] sm:h-[260px] md:invisible",
                                                    onClick: previousPhotos,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_iconify_react__WEBPACK_IMPORTED_MODULE_5__/* .Icon */ .JO, {
                                                        icon: "material-symbols:chevron-left-rounded",
                                                        className: "flex items-center ml-6 w-[50px] h-[50px] text-white"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                    className: "flex justify-end items-center cursor-pointer w-1/2 md:h-[400px] sm:h-[260px] md:invisible",
                                                    onClick: nextPhotos,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_iconify_react__WEBPACK_IMPORTED_MODULE_5__/* .Icon */ .JO, {
                                                        icon: "material-symbols:chevron-right-rounded",
                                                        className: "w-[50px] h-[50px] text-white flex mr-6 "
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {})
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                }),
                videoModalOpen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_17__/* .motion.div */ .E.div, {
                    initial: {
                        opacity: 0
                    },
                    animate: {
                        opacity: 1
                    },
                    transition: {
                        duration: 0.2
                    },
                    className: "absolute w-full h-full bg-[rgba(0,0,0,0.5)] flex justify-center items-center flex-col",
                    onClick: ()=>{
                        cancelVideoModalOpen();
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("video", {
                        controls: true,
                        autoPlay: true,
                        id: "video",
                        preload: "auto",
                        loop: false,
                        muted: false,
                        className: "max-w-[80%] max-h-[80%]",
                        src: photosPaseUrl + currentVideo.original_url,
                        onClick: (e)=>e.stopPropagation()
                    })
                }),
                isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "absolute inset-0 z-[20] bg-[#FFF] rounded-[10px]",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_ContentLoading__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {})
                }) : null,
                selectedData.length > 0 || isLoading || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: "text-center px-2 absolute inset-0 flex justify-center items-center pointer-events-none",
                    children: [
                        t("It appears theres no data to show here yet"),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                        t("If data exists it may take up to 1 hour to download and appear"),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                        t("We suggest checking back in a little while")
                    ]
                })
            ]
        })
    });
}


/***/ }),

/***/ 74249:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contentLoadingRoot":"ContentLoading_contentLoadingRoot__ypzGH","contentLoadingRootFullScreen":"ContentLoading_contentLoadingRootFullScreen__ZmB8e","contentLoadingSpinner":"ContentLoading_contentLoadingSpinner__4vCxU","content-loading-spin":"ContentLoading_content-loading-spin__K0YUP","contentLoadingLabel":"ContentLoading_contentLoadingLabel__S0w79"};

/***/ }),

/***/ 92703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(50414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 45697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(92703)();
}


/***/ }),

/***/ 50414:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 7297:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _taggedTemplateLiteral; }
/* harmony export */ });
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,1954,518,6664,607,9774,2888,179], function() { return __webpack_exec__(89479); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);